import { switchMap, takeUntil } from 'rxjs/operators';
import { ReplaySubject, Subject, Subscription } from 'rxjs';
import { Setting } from './../../../../shared/models/setting.model';
import { ConfirmModalComponent } from './../../../../shared/components/confirm-modal/confirm-modal.component';
import { AfterViewInit, Component, Inject, OnInit, Input, TemplateRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { NbToastrService, NbDialogRef } from '@nebular/theme';
import { ChangeDetectorRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, FormArray, FormBuilder } from '@angular/forms';
import { NbAuthService, NbAuthJWTToken } from '@nebular/auth';
import { RxFormBuilder, model } from '@rxweb/reactive-form-validators';
import { HeaderComponent } from 'src/app/@theme/components';
import { HeadshotComponent } from 'src/app/shared/components/headshot/headshot.component';
import { TblActionType } from 'src/app/shared/enums/tbl-action-type.enum';
import { UserModel, UserPhoneNumber } from '../user-model';
import { UserRoleModel } from '../user-role-model';
import { UserService } from '../user.service';
import { ActivatedRoute } from '@angular/router';
import { F } from '@angular/cdk/keycodes';
import { QuillConfiguration } from 'src/app/shared/components/stand-alone-component/rich-inline-edit/rich-inline-edit.component';
import { Helper } from 'src/app/shared/utility/Helper'
import { Clipboard } from '@angular/cdk/clipboard';
import { SettingService } from 'src/app/shared/services/setting.service';
import { Language, ISO_639_1_LANGUAGES, POPULAR_LANGUAGES } from 'src/app/shared/constants/iso-639-1-languages';
import { MatChipInputEvent } from '@angular/material/chips';
import { COMMA, ENTER, SEMICOLON, SPACE } from '@angular/cdk/keycodes';

@Component({
  selector: 'app-add-edit-user',
  templateUrl: './add-edit-user.component.html',
  styleUrls: ['./add-edit-user.component.scss']
})
export class AddEditUserComponent implements OnInit {
  @Input() editable: boolean = false;
  @ViewChild(HeadshotComponent) headShot: HeadshotComponent;
  @ViewChild('textConfirmGenerate', { static: true }) textConfirmGenerate: TemplateRef<any>;
  @ViewChild('copyDialogContainer', { static: true }) copyDialogContainer: TemplateRef<any>;
  //2022-03-17 thoainda start add
  private destroyed$ = new Subject();
  private routeSub: Subscription;
  id: string;
  //2022-03-17 thoainda end add
  isInputShown: boolean;
  action: TblActionType;
  userModel: UserModel;
  frmUser: FormGroup;
  readonlyCaller = false;
  isLoading = false;
  isLoadingProfile = false;
  isLoadingApiToken = false;
  listRoles: UserRoleModel[] = [];
  editorOptions = QuillConfiguration
  maskedApiToken: string = "";
  fullApiToken: string = "";
  generateMessage: string = "";
  isCopy: boolean = false;
  isCustomer: boolean = false;
  isChangePassword: boolean = false;
  listUser: UserModel[] = [];
  SelectSearchInput = new FormControl();
  isShowCallFlowData: boolean = false;
  public filteredUsers: ReplaySubject<UserModel[]> = new ReplaySubject<UserModel[]>(1);
  private searchInitialized = false;
  
  // Language properties
  languageSearchCtrl: FormControl = new FormControl();
  availableLanguages: Language[] = ISO_639_1_LANGUAGES;
  popularLanguages: Language[] = POPULAR_LANGUAGES;
  showAllLanguages: boolean = true;

  // Callflow phone numbers chip properties
  callFlowPhoneNumbers: string[] = [];
  separatorKeysCodes: number[] = [ENTER, COMMA, SEMICOLON, SPACE];

  constructor(
    public dialModalRef: MatDialogRef<AddEditUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userService: UserService,
    private frmBuilder: RxFormBuilder,
    private fb: FormBuilder,
    private authService: NbAuthService,
    private toast: NbToastrService,
    private cdref: ChangeDetectorRef,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private clipboard: Clipboard,
    private settingService: SettingService
  ) {
    if (data.model) {
      this.id = data.model.id;
    }
    this.id = data.id ?? this.id;
    this.action = data.action;
    this.userModel = data.model ?? new UserModel();
    this.userModel.experienceLevel = this.userModel.experienceLevel ?? 'New';
    this.userModel.action = data.action;
    this.routeSub = this.activatedRoute.params.pipe(
      takeUntil(this.destroyed$)
    ).subscribe(params => {
      if (params.id !== undefined) {
        this.userModel.id = params.id;
      }
    });
    this.authService.onTokenChange()
      .subscribe((token: NbAuthJWTToken) => {
        if (token.isValid()) {
          this.user = token.getPayload();
        }
      });
      
    this.userService.getAllUser();
  }
  user;
  dataEntryRole: Setting;
  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }
  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
  ngOnInit() {
    // Initialize phoneNumbers array for new users
    if (this.action == TblActionType.Add) {
      if (!this.userModel.phoneNumbers) {
        this.userModel.phoneNumbers = [];
      }
      if (this.userModel.phoneNumbers.length === 0) {
        this.userModel.phoneNumbers.push({
          userPhoneNumberId: 0,
          phoneNumber: '',
          outboundTrunk: '',
          isPrimary: true
        });
      } else {
        // Ensure at least one primary contact exists
        const hasPrimary = this.userModel.phoneNumbers.some(phone => phone.isPrimary);
        if (!hasPrimary && this.userModel.phoneNumbers.length > 0) {
          this.userModel.phoneNumbers[0].isPrimary = true;
        }
      }
    }

    if (this.userModel.phoneNumbers && this.userModel.phoneNumbers.length > 0) {
      this.userModel.phoneNumbers = this.userModel.phoneNumbers.map(phone => ({
        userPhoneNumberId: (phone as any).userPhoneNumberId || 0,
        phoneNumber: phone.phoneNumber || '',
        outboundTrunk: phone.outboundTrunk || '',
        isPrimary: phone.isPrimary || false
      }));
    }

    this.userModel.experienceLevel = this.userModel.experienceLevel ?? 'New';
    this.frmUser = this.frmBuilder.formGroup(UserModel, this.userModel);
    
    // Add phoneNumbers FormArray to the form
    this.frmUser.addControl('phoneNumbers', this.createPhoneNumbersFormArray());
    
    // Initialize callflow phone numbers chips for all cases
    this.initializeCallFlowPhoneNumbers();
    
    this.dialModalRef.updatePosition({ right: '0', });
    this.userService.getRoles().subscribe(res => {
      if (res != null && res.length > 0) {
        this.listRoles = [...res];
      }
    });
    this.setupProfileUser();

    this.userService.getAPIToken(this.id).pipe(takeUntil(this.destroyed$)).subscribe({
      next: (data) => {
        this.maskedApiToken = data.result;
      }
    })
    
    this.userService.allUserList().pipe(takeUntil(this.destroyed$)).subscribe(e => {
      this.listUser = e.filter(x => x.id != this.id);
      // Initialize filtered list after data is loaded
      this.filteredUsers.next(this.listUser.slice());
      
      // Setup search functionality only once after data is loaded
      if (!this.searchInitialized) {
        this.searchInitialized = true;
        this.SelectSearchInput.valueChanges
        .pipe(takeUntil(this.destroyed$))
        .subscribe(() => {
          this.filterUsers();
        });
      }
    });
  }
  filterUsers() {
    if (!this.listUser) {
      return;
    }
    let search = this.SelectSearchInput.value;
    if (!search) {
      this.filteredUsers.next(this.listUser.slice());
      return;
    }
    else {
      search = search.toLowerCase();
    }
    this.filteredUsers.next(
      this.listUser.filter(user => user.userName.toLowerCase().indexOf(search) > -1)
    );
  }
  async setupProfileUser() {
    try {
      if (this.action == 3) {
        this.isLoadingProfile = true;
        var data = await this.userService.getUserById(this.id).pipe(takeUntil(this.destroyed$)).toPromise();

        this.userModel = data.result;
        this.userModel.experienceLevel = this.userModel.experienceLevel ?? 'New';
        var arrayRole = [this.user.role.toString()];
        arrayRole = [...arrayRole[0].split(',')];
        var existingRoleAdmin = arrayRole.find(x => x == "admin");
        if (existingRoleAdmin == "admin") {
          this.readonlyCaller = false;
        } else {
          this.readonlyCaller = true;
        }

        let respCusRole = await this.settingService.getSettingByKeyAndGroup("CUSTOMER_ROLE_ID", "CUSTOMER").toPromise();
        this.isCustomer = this.userModel?.roles?.findIndex(x => x == respCusRole?.result?.value) >= 0;

        // Initialize phoneNumbers array if empty
        if (!this.userModel.phoneNumbers) {
          this.userModel.phoneNumbers = [];
        }

        // Debug: Log loaded phoneNumbers with IDs
        console.log('Loaded phoneNumbers from backend:', this.userModel.phoneNumbers);
        
        // Map userPhoneNumberId to id for frontend compatibility
        if (this.userModel.phoneNumbers && this.userModel.phoneNumbers.length > 0) {
          this.userModel.phoneNumbers = this.userModel.phoneNumbers.map(phone => ({
            userPhoneNumberId: (phone as any).userPhoneNumberId || 0,
            phoneNumber: phone.phoneNumber || '',
            outboundTrunk: phone.outboundTrunk || '',
            isPrimary: phone.isPrimary || false
          }));
        }
        
        console.log('Mapped phoneNumbers for frontend:', this.userModel.phoneNumbers);
        this.userModel.phoneNumbers?.forEach((phone, index) => {
          console.log(`Mapped Phone ${index}: ID="${phone.userPhoneNumberId}", Number="${phone.phoneNumber}", Primary=${phone.isPrimary}`);
        });

        // If single phone number exists but no phoneNumbers array, migrate it
        if (this.userModel.phoneNumber && this.userModel.phoneNumbers.length === 0) {
          this.userModel.phoneNumbers.push({
            userPhoneNumberId: 0,
            phoneNumber: this.userModel.phoneNumber,
            outboundTrunk: '',
            isPrimary: true
          });
        }

        // Ensure at least one empty phone number entry for new user
        if (this.userModel.phoneNumbers.length === 0) {
          this.userModel.phoneNumbers.push({
            userPhoneNumberId: 0,
            phoneNumber: '',
            outboundTrunk: '',
            isPrimary: true
          });
        } else {
          // Ensure at least one primary contact exists
          const hasPrimary = this.userModel.phoneNumbers.some(phone => phone.isPrimary);
          if (!hasPrimary && this.userModel.phoneNumbers.length > 0) {
            this.userModel.phoneNumbers[0].isPrimary = true;
          }
        }

        // Update FormArray with loaded data
        if (this.frmUser.get('phoneNumbers')) {
          this.frmUser.setControl('phoneNumbers', this.createPhoneNumbersFormArray());
        }

        // Patch Callflow fields and any others to form controls
        if (this.frmUser) {
          this.frmUser.patchValue({
            callFlowMobilePhoneNumber: this.userModel.callFlowMobilePhoneNumber,
            callFlowLanguage: this.userModel.callFlowLanguage
          });
          
          // Initialize callflow phone numbers chips
          this.initializeCallFlowPhoneNumbers();
        }
      }
    }
    catch (ex) {
      console.error(ex);
    }
    finally {
      this.isLoadingProfile = false;
    }
  }

  closeDialog() {
    this.dialModalRef.close();
  }


  saveData() {
    if (this.frmUser.valid && this.validateFormArrayPhoneNumbers()) {
      this.isLoading = !this.isLoading;
      const model: UserModel = Object.assign({}, this.frmUser.value);
      model.experienceLevel = model.experienceLevel ?? 'New';
      model.base64IMG = this.headShot.pictureHeadShot?.substring(this.headShot.pictureHeadShot?.lastIndexOf(',') + 1);
      model.pictureURL = this.userModel.pictureURL;

      // Clean up empty phone numbers before sending
      if (model.phoneNumbers) {
        model.phoneNumbers = model.phoneNumbers.filter(phone => 
          phone && phone.phoneNumber && phone.phoneNumber.trim() !== ''
        );

        // Ensure at least one primary contact exists
        if (model.phoneNumbers.length > 0) {
          const hasPrimary = model.phoneNumbers.some(phone => phone.isPrimary === true);
          
          if (!hasPrimary) {
            // Set first phone number as primary if no primary exists
            model.phoneNumbers[0].isPrimary = true;
            console.log('No primary contact found, setting first phone as primary');
          }
        }
      }
      model.phoneNumber = model.phoneNumbers.find(x => x.isPrimary)?.phoneNumber;
      
      // Debug: Log the phoneNumbers data with mapped IDs
      console.log('Phone Numbers being sent with mapped IDs:', model.phoneNumbers);
      model.phoneNumbers?.forEach((phone, index) => {
        console.log(`Phone ${index}: ID="${phone.userPhoneNumberId}", UserPhoneNumberId="${(phone as any).userPhoneNumberId}", Number="${phone.phoneNumber}", Primary=${phone.isPrimary}`);
      });
      console.log('Full model payload:', JSON.stringify(model, null, 2));
      
      if (this.action == 0) model.isActive = true;
      let isEmptyPassword = false;
      if (this.action == 0 && !model.password && !model.confirmPassword) {
        isEmptyPassword = true;
        model.password = Helper.makeid(6);
      }

      this.userService.saveUser(model).subscribe(resp => {
        if (resp.result) {
          this.toast.success(`Save user ${model.userName} successfully`, 'Success');

          if (this.action == 0 && isEmptyPassword) {
            this.userService.sendEmailResetPassword(resp.result.id).subscribe(emailResp => {
              if (emailResp.result) {
                this.toast.success(
                  `Please check email ${resp.result.email} to reset password`,
                  "Success")
              }
            })
          }

          this.dialModalRef.close(resp.result);
          if (this.action == TblActionType.Profile) {
            this.userService.pictureURLChange.next(resp.result.pictureURL?.replaceAll('\\', '/'));
          }
        }
      }).add(() => {
        this.isLoading = !this.isLoading;
      })
    }
  }

  openPopupCopyToken() {
    this.isLoadingApiToken = true;
    this.userService.generateAPIToken(this.id).subscribe({
      next: (response) => {
        if (response.result) {
          this.fullApiToken = window.atob(response.result);
          // var maskedToken = this.fullApiToken.slice(0, 6).padEnd(this.fullApiToken.length, "*");
          this.maskedApiToken = this.fullApiToken;
          this.dialog.open(ConfirmModalComponent, {
            data: {
              externalTemplate: this.copyDialogContainer,
              yesTitle: "DISABLED",
              falseTitle: "Close",
            }
          });
        }
      },
      error: (error) => {
        console.error('Error generating API token:', error);
        this.toast.danger('Failed to generate API token', 'Error');
      },
      complete: () => {
        this.isLoadingApiToken = false;
      }
    })
  }

  generateToken(e) {
    e.preventDefault();
    if (this.maskedApiToken != null) {
      this.generateMessage = `Are you sure you want to generate new API Token? The old API Token will be disabled, and all the applications connected to it may not work properly`;
      const dialogRef = this.dialog.open(ConfirmModalComponent, {
        data: {
          externalTemplate: this.textConfirmGenerate,
        }
      });

      dialogRef.afterClosed().subscribe(response => {
        if (response) {
          this.openPopupCopyToken()
        }
      });
    } else {
      this.openPopupCopyToken();
    }
  }

  onCopyClick() {
    this.clipboard.copy(this.fullApiToken);
    this.toast.success('Copied this API Token to clipboard', 'Success');
    this.isCopy = true;
    setTimeout(() => {
      this.isCopy = false;
    }, 2000);
  }

  async confirmChangePassword() {
    let dialogConfirm = this.dialog.open(ConfirmModalComponent, {
      data: { message: "Do you wish to change password?" }
    });

    let resp = await dialogConfirm.afterClosed().toPromise();
    if (resp) this.isChangePassword = true;
  }

  // FormArray management methods
  createPhoneNumbersFormArray(): FormArray {
    const phoneNumbers = this.userModel.phoneNumbers || [];
    // Create FormArray manually to avoid RxWeb conflicts
    const formArray = new FormArray([]);
    
    phoneNumbers.forEach(phone => {
      const group = this.createPhoneNumberFormGroup(phone);
      formArray.push(group);
    });
    
    return formArray;
  }

  createPhoneNumberFormGroup(phone: UserPhoneNumber): FormGroup {
    // Use RxFormBuilder for consistency with main form
    const group = this.frmBuilder.formGroup(UserPhoneNumber, phone);
    
    // Add unique identifier for trackBy
    (group as any)._uniqueId = Date.now() + Math.random();
    
    return group;
  }

  get phoneNumbersFormArray(): FormArray {
    return this.frmUser.get('phoneNumbers') as FormArray;
  }

  addPhoneNumber() {
    // Use the createPhoneNumberFormGroup method for consistency
    const newPhoneGroup = this.createPhoneNumberFormGroup({
      userPhoneNumberId: 0,
      phoneNumber: '',
      outboundTrunk: '',
      isPrimary: false
    });
    
    this.phoneNumbersFormArray.push(newPhoneGroup);
    
    // Minimal change detection - only mark as dirty, no forced detection
    this.phoneNumbersFormArray.markAsDirty();
  }

  removePhoneNumber(index: number) {
    // Safety checks
    if (index < 0 || index >= this.phoneNumbersFormArray.length) {
      console.error('Invalid index for removePhoneNumber:', index);
      return;
    }
    
    if (this.phoneNumbersFormArray.length <= 1) {
      this.toast.warning('At least one phone number is required', 'Validation Error');
      return;
    }

    try {
      // Check if the item being removed was primary
      const controlToRemove = this.phoneNumbersFormArray.at(index);
      const isRemovingPrimary = controlToRemove.get('isPrimary')?.value === true;
      
      // Remove the control directly
      this.phoneNumbersFormArray.removeAt(index);

      // After removal, ensure we have a primary contact
      if (isRemovingPrimary) {
        // If we removed the primary, set the first remaining as primary
        if (this.phoneNumbersFormArray.controls.length > 0) {
          this.phoneNumbersFormArray.controls[0].get('isPrimary')?.setValue(true, { emitEvent: false });
        }
      } else {
        // If we didn't remove primary, double-check that we still have a primary
        const hasPrimary = this.phoneNumbersFormArray.controls.some(control => 
          control.get('isPrimary')?.value === true
        );
        
        // Safety net: if no primary exists, set first as primary
        if (!hasPrimary && this.phoneNumbersFormArray.controls.length > 0) {
          this.phoneNumbersFormArray.controls[0].get('isPrimary')?.setValue(true, { emitEvent: false });
        }
      }

      // Force change detection to ensure UI updates properly
      this.phoneNumbersFormArray.markAsDirty();
      this.phoneNumbersFormArray.updateValueAndValidity();
      
      // Use setTimeout to ensure DOM update happens after removal
      setTimeout(() => {
        this.cdref.detectChanges();
      }, 0);
      
    } catch (error) {
      console.error('Error removing phone number:', error);
      this.toast.danger('Error removing phone number', 'Error');
    }
  }

  trackByPhoneNumber(index: number, item: any): any {
    // Use the unique ID we assigned to each FormGroup
    const control = item;
    const uniqueId = (control as any)._uniqueId;
    
    if (uniqueId) {
      return uniqueId;
    }
    
    // Fallback: create unique identifier for older controls
    const id = control.get('userPhoneNumberId')?.value;
    const phoneNumber = control.get('phoneNumber')?.value;
    return `${id || 0}_${index}_${phoneNumber || ''}_${Date.now()}`;
  }

  setPrimaryContact(selectedIndex: number) {
    console.log('setPrimaryContact called with index:', selectedIndex);
    
    try {
      // Preserve all data including IDs by getting complete control data
      const currentPhoneNumbers: UserPhoneNumber[] = [];
      
      this.phoneNumbersFormArray.controls.forEach((control, index) => {
        const phoneData = {
          userPhoneNumberId: control.get('userPhoneNumberId')?.value || 0,
          phoneNumber: control.get('phoneNumber')?.value || '',
          outboundTrunk: control.get('outboundTrunk')?.value || '',
          isPrimary: index === selectedIndex // Update isPrimary based on selected index
        };
        currentPhoneNumbers.push(phoneData);
      });
      
      console.log('Updated phone numbers with preserved IDs:', currentPhoneNumbers);
      
      // Update the underlying model with preserved data
      this.userModel.phoneNumbers = currentPhoneNumbers;
      
      // Recreate the FormArray with updated data that includes IDs
      const newFormArray = this.createPhoneNumbersFormArray();
      
      // Replace the FormArray in the main form
      this.frmUser.setControl('phoneNumbers', newFormArray);
      
      // Trigger change detection
      this.cdref.detectChanges();
      
      console.log('FormArray recreated successfully with preserved IDs');
      
    } catch (error) {
      console.error('Error in setPrimaryContact:', error);
    }
  }

  validateFormArrayPhoneNumbers(): boolean {
    const phoneNumbers = this.phoneNumbersFormArray.value;
    
    if (!phoneNumbers || phoneNumbers.length === 0) {
      this.toast.warning('At least one phone number is required', 'Validation Error');
      return false;
    }

    const hasValidPhoneNumber = phoneNumbers.some(phone => 
      phone && phone.phoneNumber && phone.phoneNumber.trim() !== ''
    );

    if (!hasValidPhoneNumber) {
      this.toast.warning('At least one valid phone number is required', 'Validation Error');
      return false;
    }

    return true;
  }

  validatePhoneNumbers(): boolean {
    if (!this.userModel.phoneNumbers || this.userModel.phoneNumbers.length === 0) {
      this.toast.warning('At least one phone number is required', 'Validation Error');
      return false;
    }

    const hasValidPhoneNumber = this.userModel.phoneNumbers.some(phone => 
      phone && phone.phoneNumber && phone.phoneNumber.trim() !== ''
    );

    if (!hasValidPhoneNumber) {
      this.toast.warning('At least one valid phone number is required', 'Validation Error');
      return false;
    }

    return true;
  }

  // Callflow phone numbers chip methods
  addCallFlowPhone(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value?.trim();

    if (value) {
      // Split by semicolon or space and filter out empty strings
      const phoneNumbers = value.split(/[;\s]+/).filter(phone => phone.trim() !== '');
      
      phoneNumbers.forEach(phone => {
        const cleanPhone = phone.trim();
        if (cleanPhone && !this.callFlowPhoneNumbers.includes(cleanPhone)) {
          this.callFlowPhoneNumbers.push(cleanPhone);
        }
      });

      this.updateCallFlowFormControl();
    }

    // Clear the input value
    if (input) {
      input.value = '';
    }
  }

  removeCallFlowPhone(index: number): void {
    if (index >= 0 && index < this.callFlowPhoneNumbers.length) {
      this.callFlowPhoneNumbers.splice(index, 1);
      this.updateCallFlowFormControl();
    }
  }

  private updateCallFlowFormControl(): void {
    // Update the form control with the joined phone numbers
    const joinedPhones = this.callFlowPhoneNumbers.join(';');
    this.frmUser.get('callFlowMobilePhoneNumber')?.setValue(joinedPhones);
    this.frmUser.get('callFlowMobilePhoneNumber')?.markAsDirty();
  }

  private initializeCallFlowPhoneNumbers(): void {
    // Initialize chip array from existing form control value
    const existingValue = this.frmUser.get('callFlowMobilePhoneNumber')?.value;
    if (existingValue && typeof existingValue === 'string') {
      this.callFlowPhoneNumbers = existingValue
        .split(/[;\s]+/)
        .filter(phone => phone.trim() !== '')
        .map(phone => phone.trim());
    } else {
      this.callFlowPhoneNumbers = [];
    }
  }

  // Language methods
  getDisplayLanguages(): Language[] {
    const list = this.showAllLanguages ? this.availableLanguages : this.popularLanguages;
    const searchTerm: string = (this.languageSearchCtrl.value || '').toLowerCase().trim();
    if (!searchTerm) {
      return list;
    }
    return list.filter(lang =>
      lang.name.toLowerCase().includes(searchTerm) ||
      (lang.nativeName?.toLowerCase().includes(searchTerm)) ||
      lang.code.toLowerCase().includes(searchTerm)
    );
  }

  toggleLanguageView(event?: Event): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.showAllLanguages = !this.showAllLanguages;
  }

  getLanguageDisplay(language: Language): string {
    return `${language.name} (${language.code}) - ${language.nativeName}`;
  }
}
